import api from './api';

// 像素配置接口
export interface PixelConfig {
  id: number;
  pixel_code: string;
  pixel_name: string;
  access_token: string;
  api_secret?: string;
  status: number;
  created_at: string;
}

// 像素配置按平台分组
export interface PixelConfigsResponse {
  facebook?: PixelConfig[];
  google?: PixelConfig[];
}

// 事件类型
export interface EventType {
  code: string;
  name: string;
}

// 回传日志
export interface PostbackLog {
  id: number;
  visitor_id: number;
  platform: string;
  pixel_name: string;
  event_type: string;
  event_value?: number;
  currency?: string;
  status: 'pending' | 'success' | 'failed';
  platform_event_id?: string;
  error_message?: string;
  retry_count: number;
  created_at: string;
}

// 回传请求
export interface PostbackRequest {
  visitor_id: number;
  pixel_config_id: number;
  event_type: string;
  event_value?: number;
  currency?: string;
}

// 回传记录查询请求
export interface PostbackLogsRequest {
  platform?: string;
  status?: string;
  start_date?: string;
  end_date?: string;
  visitor_id?: number;
  page?: number;
  size?: number;
}

// 回传记录响应
export interface PostbackLogsResponse {
  list: PostbackLog[];
  total: number;
  page: number;
  size: number;
  success_count: number;
  failed_count: number;
}

// 像素服务
export const pixelService = {
  // 获取像素配置列表
  getPixelConfigs: async (): Promise<PixelConfigsResponse> => {
    const response = await api.post('/api/pixel/configs');
    return response.data.data;
  },

  // 创建像素配置
  createPixelConfig: async (data: {
    platform: string;
    pixel_code: string;
    pixel_name?: string;
    access_token?: string;
    api_secret?: string;
  }): Promise<{ id: number }> => {
    const response = await api.post('/api/pixel/configs/create', data);
    return response.data.data;
  },

  // 更新像素配置
  updatePixelConfig: async (data: {
    id: number;
    pixel_code?: string;
    pixel_name?: string;
    access_token?: string;
    api_secret?: string;
    status?: number;
  }): Promise<void> => {
    await api.post('/api/pixel/configs/update', data);
  },

  // 删除像素配置
  deletePixelConfig: async (id: number): Promise<void> => {
    await api.post('/api/pixel/configs/delete', { id });
  },

  // 获取事件类型
  getEventTypes: async (platform: string): Promise<EventType[]> => {
    const response = await api.post('/api/pixel/event-types', { platform });
    return response.data.data;
  },

  // 执行回传
  postback: async (data: PostbackRequest): Promise<{ postback_id: number; platform_event_id?: string }> => {
    const response = await api.post('/api/pixel/postback', data);
    if (!response.data.success) {
      throw new Error(response.data.message || '回传失败');
    }
    return response.data.data;
  },

  // 重试回传
  retryPostback: async (postbackId: number): Promise<void> => {
    const response = await api.post('/api/pixel/postback/retry', { postback_id: postbackId });
    if (!response.data.success) {
      throw new Error(response.data.message || '重试失败');
    }
  },

  // 获取回传记录
  getPostbackLogs: async (params: PostbackLogsRequest): Promise<PostbackLogsResponse> => {
    const response = await api.post('/api/pixel/postback/records', params);
    return response.data.data;
  },
};
